export default "__VITE_ASSET__5df33624__"